"use strict";

exports.__esModule = true;
var _AuditLogRoutes = require("./AuditLogRoutes");
Object.keys(_AuditLogRoutes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AuditLogRoutes[key]) return;
  exports[key] = _AuditLogRoutes[key];
});